<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head, usePage } from '@inertiajs/inertia-vue3';
import { mdiPlusCircle, mdiFilePdfBox, mdiFileTableOutline, mdiInformationOutline, mdiPrinter } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import BaseIcon from "@/Components/BaseIcon.vue";
import IconRounded from "@/Components/IconRounded.vue";
import VueSelect from "vue3-select-component";

const props = defineProps({
	//records: Array,
	template: String,
	title: String,
	fileName: String,
	levels: Object,
	classrooms: Object,
	classroomsugel: Object,
	//ciclos: Object,
	isAdmin: Boolean,
	isCoord: Boolean,
	plantilla: String,
	options: Object,
	anioLectivo: String

});
//let elementsDisabled = getElementsByTagName('input', 'select');
const loading = ref(false)
const resource = ref('reportstudent')
const errors = ref({})
const error = ref('')
const filters = {
	'status': 'activo'
}
const options = {
	'show_activos': true, // deprecated, se usará filers
	'show_retirados': 0,
	'show_compare': 0
}
const form = ref({
	'anio_consulta': '',
	'id_level': 0,
	'id_classroom': 0,
	'id_classroom_matricula': 0,
	'id_classroom_ugel': 0,
	'ref_ciclo': '',
	'options': options,
	'filters': filters,
	'is_sort_nombre': false,
	'sort_nombre': false,
	'is_sort_puntaje': false,
	'sort_puntaje': false,
	'template': props.template
})

const getSemanas = () => {
	const conf = usePage().props.value.confGlobal;
	if (!form.value.ref_ciclo) return [];
	let semanasStr = '';
	if (form.value.ref_ciclo === 'B1') semanasStr = conf.CICLO_PRIMER_BIMESTRE_SEMANAS;
	else if (form.value.ref_ciclo === 'B2') semanasStr = conf.CICLO_SEGUNDO_BIMESTRE_SEMANAS;
	else if (form.value.ref_ciclo === 'B3') semanasStr = conf.CICLO_TERCER_BIMESTRE_SEMANAS;
	else if (form.value.ref_ciclo === 'B4') semanasStr = conf.CICLO_CUARTO_BIMESTRE_SEMANAS;
	return semanasStr ? semanasStr.split(',') : [];
}

const records = ref([])
//const id_classroom = ref(0)
//const ref_ciclo= ref(0)
const buttonUpgrade = ref([])
const messagealert = ref([])

const getRecords = async () => {
	if (props.template == 'conductasemanal') {
		if (form.value.id_classroom == 0 || !form.value.ref_ciclo) {
			error.value = '';
			if (!form.value.id_classroom) error.value = 'Debe escoger un aula de estudio.';
			if (!form.value.ref_ciclo) error.value += (error.value ? ' ' : '') + 'Debe escoger un bimestre.';
			return false;
		} else {
			error.value = '';
		}
	} else if (props.template == 'studentslist') {
		if (!form.value.id_classroom_ugel && !form.value.id_classroom && !form.value.id_classroom_matricula && !form.value.id_level) { // <-- !form.value.ref_ciclo Para Periodo anual
			//this.$message.error('Seleccionar estudante');
			error.value = 'Debe escoger un aula o nivel'
			return false;
		} else {
			error.value = '';
		}
	} else {
		if (form.value.id_classroom == 0 || !form.value.id_level) {
			//this.$message.error('Seleccionar estudante');
			if (!form.value.id_classroom) error.value = 'Debe escoger un aula'
			if (!form.value.id_level) error.value += ' Debe escoger un nivel'
			return false;
		} else {
			error.value = '';
		}
	}

	loading.value = true
	records.value = []
	buttonUpgrade.value = []
	messagealert.value = []
	await axios.post(`/${resource.value}/records`, form.value)
		.then(response => {
			records.value = response.data;
		});
	loading.value = false;
	getTextSelectAula()
	if (props.template == 'calificationsbymerito') {
		procesarListado('calificationsbymerito')
	}
}

const sortNombre = () => {
	form.value.is_sort_nombre = true;
	form.value.is_sort_puntaje = false;
	form.value.sort_nombre = !form.value.sort_nombre;
	getRecords();
}

const exportFile = async (format) => {
	loading.value = true;
	// this.loadingSubmit = true;
	errors.value = {};
	console.log('cr_ugel ' + form.value.id_classroom_ugel)
	console.log('cr ' + form.value.id_classroom)
	console.log('ciclo ' + form.value.ref_ciclo)
	await axios({
		url: `/${resource.value}/export`,
		method: 'POST',
		responseType: 'blob',
		data: {
			'records': records.value,
			'format': format,
			'template': props.template,
			'id_level': form.value.id_level,
			'id_classroom': form.value.id_classroom,
			'id_classroom_ugel': form.value.id_classroom_ugel,
			'id_classroom_matricula': form.value.id_classroom_matricula,
			'ref_ciclo': form.value.ref_ciclo,
			'anio_consulta': form.value.anio_consulta,
			'options': JSON.stringify(options)
		}
	}).then(response => {
		let res = response.data;
		if (res.type === 'application/json') {
			//this.$message.error('Error al exportar');
			console.log('Error al exportar')
		} else {
			const url = window.URL.createObjectURL(new Blob([res]));
			const link = document.createElement('a');
			link.href = url;
			//link.setAttribute('download', 'calificacioness_' + Date.now() + '.' + format);
			if (format == 'preview') {
				link.target = "_blank";
				link.setAttribute('view', props.fileName + '.html');
			} else {
				link.setAttribute('download', props.fileName + '_' + aulaText.value + '.' + format);
			}
			document.body.appendChild(link);
			link.click();
		}
	}).catch(error => {
		console.log(error);
		errors.value = error;
	}).then(() => {
		loading.value = false;
	});
	// this.loadingSubmit = false;
	//

}

const number2nota = (notaN) => {
	let nota = parseFloat(notaN).toFixed(2);
	let result = (nota < 10.50 ? 'C' : (nota >= 10.50 && nota < 13.50 ? 'B' : (nota >= 13.50 && nota < 17.50 ? 'A' : (nota >= 17.50 && nota <= 20 ? 'AD' : 'E'))))
	//console.log(nota)
	return result
}

const aulaText = ref('')
const getTextSelectAula = () => {
	if (form.value.id_classroom > 0) {
		var values = props.classrooms.map(function (o) { return o.value }) // <-- Crear una nueva lista con map aplicando una función, antes .id ahora .value
		var index = values.indexOf(form.value.id_classroom)
		//var index = form.value.id_classroom ? form.value.id_classroom : form.value.id_classroom_ugel
		aulaText.value = props.classrooms[index].label
	}

	//console.log(index)
	console.log(aulaText.value)

}

/**
 * Estructurar nuevo listado
 */
const nuevoListadoActive = ref(false)
const nuevoListado = ref([])
const procesarListado = (template) => {
	const arrObjs = []; // Array de objetos
	const arr = records.value
	if (template == 'calificationsbymerito') {
		arr.forEach((record, index) => {
			let siexiste = checkExistObject(arrObjs, 'id_student', record.id_student)

			if (siexiste) {
				arrObjs.find(item => item.id_student === record.id_student).total_acumulado += parseInt(record.promediods)
			} else {
				arrObjs.push({
					id_student: record.id_student,
					fullname: record.fullname,
					ref_ciclo: record.ref_ciclo,
					total_acumulado: record.promediods
				});
			}

		});

		// ORdenar objetos según el campo y de mayor a menor (descendente)
		orderList('total_acumulado', 'desc', arrObjs)
	}
	// Agregar más estructuras de templates con else if('') ...

	nuevoListado.value = arrObjs
	if (arrObjs.length) {
		nuevoListadoActive.value = true
	}

	console.log(nuevoListado.value.length)
}

// Si existe el objeto según el atributo en un array de objetos
const checkExistObject = (arrObj, attr, val) => {
	return arrObj.some((obj) => obj[attr] == val)
}

// Ordenar listado
const orderList = (orderfield, sort = '', objs) => {
	objs.sort((a, b) => {
		if (sort == 'asc') {
			return a[orderfield] - b[orderfield]
		} else if (sort == 'desc') {
			return b[orderfield] - a[orderfield]
		} else {
			return a[orderfield] - b[orderfield]
		}
	});
}

// Ordenar listado sólo números no string <---------------
const sortUp = ref(false)
const sortDown = ref(false)
const sortnodefine = ref(false)
const orderColumn = (orderfield, sort = '', objs = nuevoListado.value) => {

	// Si no se define sort
	if (!sort) {
		sortnodefine.value = !sortnodefine.value
		if (sortnodefine.value) {
			sort = 'asc'
			sortUp.value = false
			sortDown.value = true
		} else {
			sort = 'desc'
			sortUp.value = true
			sortDown.value = false
		}
	}

	orderList(orderfield, sort, objs)
	nuevoListado.value = objs
	console.log('ordercolumnchanged')

}

// Calcular puesto
const calcularPuesto = (puesto, lastPuntaje, puntaje) => {
	// Si hay puntajes iguales se repite los puestos, de lo contrario se mantiene el puesto anterior <-- existen puestos duplicados
	if (lastPuntaje != puntaje) {
		puesto++
	}
	console.log(lastPuntaje + ' - ' + puntaje)
	return puesto
}

// Actualizar datos academicos de estudiante
const upgradeStudent = (id_student, id_level, id_classroom, id_classroom_matricula, id_classroom_ugel, index) => {
	let form = {
		'id_student': id_student,
		'id_level': id_level,
		'id_classroom': id_classroom,
		'id_classroom_matricula': id_classroom_matricula,
		'id_classroom_ugel': id_classroom_ugel
	}

	axios.post(`/${resource.value}/upgradestudent`, form)
		.then(response => {
			let resp = response.data;
			if (resp.success) {
				buttonUpgrade.value[index] = true
				//buttonUpgrade.value.fill(true, index, index + 1)
				console.log('Upgrade OK ' + id_student + ' - ' + index)
				//console.log(buttonUpgrade.value)
			} else {
				messagealert.value[index] = resp.message
			}
		});
}
</script>

<template>

	<Head :title="title" />

	<BreezeAuthenticatedLayout>
		<template #header>
        <PremiumPageHeader :title="title" :subtitle="'Gestión de ' + title">
            <template #buttons>
                <BaseButton :classLabel="'hidden sm:block'"
                            color="info"
                            :icon="mdiPlusCircle"
                            small
                            label=" Nuevo"
                            class="inline-flex"
                        />
            </template>
        </PremiumPageHeader>
    </template>

		<div>
			<!-- Loader -->
			<div v-if="loading" class="flex flex-col justify-center items-center md:h-[calc(100vh_-113px)] h-[calc(100vh-_114px)] absolute bottom-0 bg-white w-full z-50 bg-opacity-80">
				<!-- LRR Loader Pulso <div class="mb-10">
                    <div class="relative inline-flex">
                        <div class="w-8 h-8 bg-rose-600 rounded-full"></div>
                        <div class="w-8 h-8 bg-rose-600 rounded-full absolute top-0 left-0 animate-ping"></div>
                        <div class="w-8 h-8 bg-rose-600 rounded-full absolute top-0 left-0 animate-pulse"></div>
                    </div>
                </div> -->
				<div class="border-gray-300 h-20 w-20 animate-spin rounded-full border-8 border-t-rose-600 mb-10" />
				<p class="text-rose-600">Procesando ...</p>
				<!-- LRR Button loader <div>
                    <button type="button"
                        class="inline-flex  items-center btn btn-rose text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg ">
                        <div class="border-rose-400 h-5 w-5 animate-spin rounded-full border-4 border-t-white mr-2" />
                        Cargando
                    </button>
                </div> -->
			</div>
			<div>
				<div class="bg-white rounded-md shadow-lg p-4 border" :class="loading ? 'pointer-events-none' : ''">
					<!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
					<!-- <div>
                          <label for="list_periodo-choice">Escoge un periodo:</label>
                          <input type="search" placeholder="Periodo" list="list-periodos" id="list_periodo-choice" name="list_periodo-choice" style="width: 300px;">
                          <datalist
                              id="list-periodos"
                              name="list-periodos"
                              class="flat">
                              <option v-for="option in ciclos" :value="option.id">{{ option.label }}</option>
                          </datalist>
                        </div> -->


					<div class="mb-4 text-center">
						<input name="year" class="w-16 ml-3 rounded-lg" type="text" v-model="form.anio_consulta" :placeholder="confGlobal.value.CICLO_ANIO_ESCOLAR">
					</div>

					<div class="mb-4">
						<ul>
							<li>Por defecto se muestran los activos.</li>
						</ul>
					</div>

					<div v-if="template == 'conductasemanal'" class="grid gap-3 xl:grid-cols-3 sm:grid-cols-2 grid-cols-1 mb-4">
						<div class="col-span-1">
							<label class="block font-bold mb-2 ml-2">Bimestre</label>
							<select v-model="form.ref_ciclo" @change="getRecords()" class="w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
								<option value="" disabled>Seleccione Bimestre</option>
								<option value="B1">Primer Bimestre</option>
								<option value="B2">Segundo Bimestre</option>
								<option value="B3">Tercer Bimestre</option>
								<option value="B4">Cuarto Bimestre</option>
							</select>
						</div>
						<div class="col-span-1">
							<label class="block font-bold mb-2 ml-2">Aula de estudio</label>
							<VueSelect class="select-search-light max-h-[38px]" v-model="form.id_classroom" :options="classrooms" :get-option-label="(option) => `${option.label}`" placeholder="Seleccionar aula de estudio" />
							<small v-if="classrooms.length <= 0" class="text-red-500">Es probable que no tenga permisos para las aulas de estudio</small>
						</div>
					</div>
					<template v-else>
						<div class="grid gap-3 xl:grid-cols-4 sm:grid-cols-2 grid-cols-1 mb-4">
							<div class="col-span-1">
								<label class="block font-bold ">Nivel/Grado</label>
								<select v-model="form.id_level" class="w-full">
									<option value="0" selected></option>
									<option v-for="option in levels" :value="option.value">{{ option.label }}</option>
								</select>
							</div>
							<div class="col-span-1">
								<label class="block font-bold">Aula de estudio</label>
								<VueSelect class=" select-search-light max-h-[38px]" v-model="form.id_classroom" :options="classrooms" :get-option-label="(option) => `${option.label}`" placeholder="" />
							</div>
							<div class="col-span-1">
								<label class="block font-bold">Aula matrícula</label>
								<VueSelect class=" select-search-light max-h-[38px]" v-model="form.id_classroom_matricula" :options="classrooms" :get-option-label="(option) => `${option.label}`" placeholder="" />

							</div>
							<div class="col-span-1">
								<label class="block font-bold">Aula UGEL</label>
								<VueSelect class="select-search-light max-h-[38px]" v-model="form.id_classroom_ugel" :options="classroomsugel" :get-option-label="(option) => `${option.label}`" placeholder="" />
							</div>
						</div>
						<div class="flex flex-col md:flex-row gap-3 mb-4">
							<template class="block">
								<label for="filters_status" class="select mb-2 ml-2">Estado</label>
								<select v-model="filters.status" id="filters_status" class="ml-2">
									<option value="activo">Activo</option>
									<option value="retirado">Retirado</option>
									<option value="promovido">Promovido</option>
									<option value="activoretirado">Activo y Retirado</option>
									<option value="todo">Todo</option>
								</select>
							</template>
							<template v-if="!form.anio_consulta" class="block mt-2">
								<input id="show_compare" v-model="options.show_compare" type="checkbox" class="ml-2" />
								<label for="show_compare" class="checkbox mb-2 ml-2">Comparar historia de aulas {{ confGlobal.value.CICLO_ANIO_ESCOLAR + ' - ' + (parseInt(confGlobal.value.CICLO_ANIO_ESCOLAR) - 1) }} (<span class="text-red-600">inconsistencias</span>)</label>
							</template>
						</div>
					</template>
					<!-- <div class="mt-4">
                          <div class="relative">
                            <label class="block font-bold mb-2 ml-1">Estudiante</label>
                            <select v-model="form.id_student" @change="getRecords()"
                              class="inline-block ml-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                              <option value="0" selected>Todos</option>
                              <option v-for="option in students" :value="option.id">{{ option.apellidos + ' ' + option.nombres }}</option>
                            </select>
                          </div>
                        </div> -->

					<div class="flex flex-wrap gap-3"> <!-- v-if="records.length" -->
						<!-- <div class="inline-block pr-2 ml-1" @click="exportFile('pdf')">
                            Exportar
                            <IconRounded color="" :icon="mdiFilePdfBox" title="Exportar a PDF" class="ml-1 text-red-800"
                             /> 
                          </div> -->
						<!-- Botones exportar -->
						<!-- <div class="inline-block" v-if="$page.props.auth.user.id_rol == 1">
                             <BaseButton
                              :disabled="records.length <= 0"
                              @click="exportFile('preview')"
                              color="info"
                              :icon="mdiFileTableOutline"
                              label="Vista debug txt"
                              small
                              target="_blank"
                              />
                          </div>
                          <div class="inline-block">
                             <BaseButton
                              :disabled="records.length <= 0 || loading"
                              :class="records.length <= 0 ? 'pointer-events-none' : ''"
                              :href="'/reportcalification/export/preview?template='+template+'&options='+JSON.stringify(options)+'&ref_ciclo='+form.ref_ciclo+'&id_classroom='+form.id_classroom+'&id_classroom_ugel='+form.id_classroom_ugel+'&anio_consulta='+form.anio_consulta"
                              color="info"
                              :icon="mdiFileTableOutline"
                              label="Vista previa"
                              small
                              target="_blank"
                              />
                          </div>
                          <div class="inline-block">
                             <BaseButton
                              :disabled="records.length <= 0 || loading"
                              @click="exportFile('xlsx')"
                              color="success"
                              :icon="mdiFileTableOutline"
                              label="Exportar"
                              small
                              target="_blank"
                              />
                          </div> -->
						<div v-if="nuevoListado.length" class="inline-block">
							<BaseButton :disabled="records.length <= 0 || loading" @click="nuevoListadoActive = !nuevoListadoActive" color="warning" :icon="mdiFileTableOutline" :label="nuevoListadoActive ? 'Ver detalle de lista' : 'Ver lista original'" small />
						</div>
						<div class="inline-block">
							<BaseButton @click="getRecords()" color="danger" :icon="mdiFileTableOutline" label="Procesar Consulta" small />
						</div>
						<!-- <div v-if="records.length > 0 && template === 'conductasemanal'" class="inline-block">
							<BaseButton
								:disabled="loading"
								@click="exportFile('preview')"
								color="info"
								:icon="mdiFileTableOutline"
								label="Vista Previa"
								small
							/>
						</div> -->
						<div v-if="records.length > 0 && template === 'conductasemanal'" class="inline-block">
							<BaseButton
								:disabled="loading"
								@click="exportFile('xlsx')"
								color="success"
								:icon="mdiFileTableOutline"
								label="Exportar Excel"
								small
							/>
						</div>
						<div v-if="records.length > 0 && template === 'conductasemanal'" class="inline-block">
							<BaseButton
								:disabled="loading"
								@click="exportFile('pdf')"
								color="warning"
								:icon="mdiFilePdfBox"
								label="PDF Horizontal"
								small
							/>
						</div>
						<!-- More buttons -->
						<!-- <div class="inline-block">
                            <BaseButton
                              @click="getRecords()"
                              color="danger"
                              :icon="mdiFileTableOutline"
                              label="Procesar"
                              small
                              />
                          </div> -->


						<!-- <div v-if="modulo=='payementOrder' && showDownloadTxt && countChecked" class="inline-block">
                            <IconRounded color="" :icon="mdiFileDocument" title="Exportar a txt" class="ml-1 text-blue-700"
                            @click="exportFile('txt')" />
                          </div> -->
					</div>
					<div class="mt-6">Total {{ records.length }}</div>
					<hr class="mt-2 mb-2">
					<CardBox v-if="records.length" class="mb-6" has-table>
						<!-- Tablesingle opciones: checkable -->
						<div class="w-full overflow-x-auto">
							<!-- listado dependiendo del template -->
							<table v-if="nuevoListado.length && template == 'calificationsbymerito' && nuevoListadoActive" class="table-responsive">
								<thead>
									<tr>
										<th>#</th>
										<th>Nombre</th>
										<th title="La suma de todos los promedios" @click="orderColumn('total_acumulado')">Puntaje Acumulado
											<span v-if="sortUp" class="text-red-600">(^)</span>
											<span v-else-if="sortDown" class="text-red-600">(v)</span>
											<span v-else></span>
										</th>
										<th>Puesto</th>
										<th></th>
									</tr>
								</thead>
								<tbody :set="objPuntaje = { lastPuntaje: 0, puesto: 0 }">
									<tr v-for="(row, index) in nuevoListado" :key="row.id">
										<td data-label="#">
											{{ index + 1 }}
										</td>
										<td data-label="Nombre" :set="puesto = calcularPuesto(objPuntaje.puesto, objPuntaje.lastPuntaje, row.total_acumulado)">
											{{ row.fullname }}
										</td>
										<!-- Primero calculamos el puntaje luego agregamos el lastPuntaje -->
										<td data-label="Puntaje Acumulado" :set="objPuntaje.puesto = puesto">
											{{ row.total_acumulado }}
										</td>
										<td data-label="Puesto" :set="objPuntaje.lastPuntaje = row.total_acumulado">
											{{ puesto }}
										</td>
										<td data-label="Action">

											<!-- BaseButtons genera error EN EL PUESTO -->
											<BaseButton color="info" :icon="mdiPrinter" label="Diploma" small :href="'/calification/diploma' + '?id=' + row.id_student + '&puesto=' + puesto + '&anio_consulta=' + form.anio_consulta" target="_blank" />

										</td>
									</tr>
								</tbody>
							</table>
							<!-- Tabla de Conducta Semanal -->
							<table v-else-if="template == 'conductasemanal'" class="table-responsive">
								<thead>
									<tr>
										<th class="text-center font-bold">#</th>
										<th class="font-bold">Nombre</th>
										<th v-for="sem in getSemanas()" :key="sem" class="text-center font-bold">
											Sem. {{ sem }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(row, index) in records" :key="row.id">
										<td data-label="#" class="text-center">
											{{ index + 1 }}
										</td>
										<td data-label="Nombre" class="font-medium text-slate-800 dark:text-slate-200">
											<Link :href="'/student/card?id=' + row.id" class="text-blue-600 hover:text-green-600">{{ row.fullname }}</Link>
										</td>
										<td v-for="sem in getSemanas()" :key="sem" :data-label="'Sem. ' + sem" class="text-center border-l border-slate-100 dark:border-slate-700">
											<span v-if="row.conductas && row.conductas[sem]" 
												  :class="[
													'inline-block px-2 py-0.5 rounded text-xs font-bold transition-all hover:scale-110 cursor-pointer',
													row.conductas[sem].calification === 'AD' ? 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/40 dark:text-indigo-400' : '',
													row.conductas[sem].calification === 'A' ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-400' : '',
													row.conductas[sem].calification === 'B' ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-400' : '',
													row.conductas[sem].calification === 'C' ? 'bg-rose-100 text-rose-800 dark:bg-rose-900/40 dark:text-rose-400' : ''
												  ]"
												  :title="row.conductas[sem].content || 'Sin comentarios'">
												{{ row.conductas[sem].calification }}
											</span>
											<span v-else class="text-slate-300 dark:text-slate-600">-</span>
										</td>
									</tr>
								</tbody>
							</table>
							<!-- Listado Original -->
							<table v-else class="table-responsive">
								<thead>
									<tr>
										<th>#</th>
										<th @click="sortNombre">Nombre
											<i v-if="form.is_sort_nombre && form.sort_nombre" class="fas fa-sort-up"></i>
											<i v-else-if="form.is_sort_nombre" class="fas fa-sort-down"></i>
											<i v-else class="fas fa-sort"></i>
										</th>
										<th>Nivel</th>
										<th>Aula estudio</th>
										<th>Aula matrícula</th>
										<th>Aula UGEL</th>
										<th>Estado</th>
										<th v-if="options.show_compare">Nivel {{ anioLectivo - 1 }}</th>
										<th v-if="options.show_compare">Aula estudio {{ anioLectivo - 1 }}</th>
										<th v-if="options.show_compare">Aula matrícula {{ anioLectivo - 1 }}</th>
										<th v-if="options.show_compare">Aula UGEL {{ anioLectivo - 1 }}</th>
										<th v-if="options.show_compare">Estado {{ anioLectivo - 1 }}</th>
										<th>Action</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(row, index) in records" :key="row.id">
										<td data-label="#">
											{{ index + 1 }}
										</td>
										<td data-label="Nombre">
											<Link :href="'/student/card?id=' + row.id" class="text-blue-600 hover:text-green-600">{{ row.fullname }}</Link>
										</td>
										<td data-label="Nivel">
											{{ row.label_level ?? '' }}
										</td>
										<td data-label="Aula estudio">
											{{ row.label_classroom ?? '' }}
										</td>
										<td data-label="Aula matricula">
											{{ row.label_classroom_matricula ?? '' }}
										</td>
										<td data-label="Aula UGEL">
											<!-- {{ row.id_classroom_ugel ? row.label_classroom_ugel : '' }} -->
											{{ row.label_classroom_ugel ?? '' }}
										</td>
										<td data-label="Estado">
											<span :class="(row.status_student == 0 ? 'text-red-600' : (row.status_student == 1 ? 'text-green-600' : ''))">
												{{ (row.status_student == 0 ? 'Retirado' : (row.status_student == 1 ? 'Activo' : (row.status_student == -1 ? 'Promovido' : row.status_studen))) }}
											</span>
										</td>

										<td v-if="options.show_compare" data-label="Nivel">
											{{ row.story_label_level ?? '' }} ->
											<small :class="(row.label_level == row.upgrade_label_level ? '' : 'text-red-600')">
												{{ row.upgrade_label_level ?? '' }}
											</small>
										</td>
										<td v-if="options.show_compare" data-label="Aula estudio">
											{{ row.story_label_classroom ?? '' }} ->
											<small :class="(row.label_classroom == row.upgrade_label_classroom ? '' : 'text-red-600')">
												{{ row.upgrade_label_classroom ?? '' }}
											</small>
										</td>
										<td v-if="options.show_compare" data-label="Aula matricula">
											{{ row.story_label_classroom_matricula ?? '' }} ->
											<small :class="(row.label_classroom_matricula == row.upgrade_label_classroom_matricula ? '' : 'text-red-600')">
												{{ row.upgrade_label_classroom_matricula ?? '' }}
											</small>
										</td>
										<td v-if="options.show_compare" data-label="Aula UGEL">
											{{ row.story_label_classroom_ugel ?? '' }} ->
											<small :class="(row.label_classroom_ugel == row.upgrade_label_classroom_ugel ? '' : 'text-red-600')">
												{{ row.upgrade_label_classroom_ugel ?? '' }}
											</small>
										</td>
										<td v-if="options.show_compare" data-label="Estado">
											<span :class="(row.story_status_student == 0 ? 'text-red-600' : (row.story_status_student == 1 ? 'text-green-600' : ''))">
												{{ (row.story_status_student == 0 ? 'Retirado' : (row.story_status_student == 1 ? 'Activo' : row.story_status_student)) }}
											</span>
										</td>
										<td v-if="options.show_compare" data-label="Action" :set="buttonUpgrade.push(false)">
											<BaseButton v-if="row.status_student == 1 && row.upgrade_id_level > 0 && (row.label_level != row.upgrade_label_level || row.label_classroom != row.upgrade_label_classroom
												|| row.label_classroom_matricula != row.upgrade_label_classroom_matricula || row.label_classroom_ugel != row.upgrade_label_classroom_ugel)" :color="(!buttonUpgrade[index] ? 'info' : 'success')" :label="(!buttonUpgrade[index] ? 'Actualizar Nivel y Aulas' : 'Actualizado')" small @click="upgradeStudent(row.id, row.upgrade_id_level, row.upgrade_id_classroom, row.upgrade_id_classroom_matricula, row.upgrade_id_classroom_ugel, index)" />
											<small :set="messagealert.push('')" class="text-red-600">
												{{ messagealert[index] }}
											</small>
											<!-- {{ buttonUpgrade[index] }} -->
										</td>
										<td v-else>
											<BaseButtons type="justify-start" no-wrap><!--lg:justify-end-->
												<BaseButton color="info" :icon="mdiPrinter" label="Libreta" small :href="'/calification/libreta' + '?id=' + row.id + '&anioSearch=' + form.anio_consulta + '&print=1'" target="_blank" />
											</BaseButtons>
										</td>
										<!--<td data-label="Progress" class="lg:w-32">
                                    <progress
                                        class="flex w-2/5 self-center lg:w-full"
                                        max="100"
                                        :value="row.progress"
                                    >
                                        {{ row.progress }}
                                    </progress>
                                    </td>
                                    -->

									</tr>
								</tbody>
							</table>
						</div>

					</CardBox>
					<CardBox v-else>
						<CardBoxComponentEmpty />
					</CardBox>

			</div>
		</div>
		</div>
	</BreezeAuthenticatedLayout>
</template>